import React from 'react';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import {
  FormSection,
  FormLabel,
  FormInput,
  FormGridRow,
  AlertBox,
  AlertTitle,
  AlertDescription,
  ErrorText,
  HelperText,
} from '../styles';
import { isValidEmail } from '../utils/helpers';

interface FormEmailConfigProps {
  formData: any;
  onFormChange: (field: string, value: any) => void;
}

const FormEmailConfig: React.FC<FormEmailConfigProps> = ({ formData, onFormChange }) => {
  const isEmailValid = !formData.fromEmail || isValidEmail(formData.fromEmail);

  return (
    <FormSection>
      <AlertBox type="info">
        <AlertTitle>📧 {TEMPLATE_FORM_CONSTANTS.MESSAGES.EMAIL_CONFIGURATION}</AlertTitle>
        <AlertDescription>{TEMPLATE_FORM_CONSTANTS.MESSAGES.EMAIL_CONFIGURATION_DESC}</AlertDescription>
      </AlertBox>

      <FormGridRow>
        <div>
          <FormLabel className="required">{TEMPLATE_FORM_CONSTANTS.LABELS.FROM_EMAIL}</FormLabel>
          <FormInput
            type="email"
            value={formData.fromEmail}
            onChange={(e) => onFormChange('fromEmail', e.target.value)}
            placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.FROM_EMAIL}
            style={{
              borderColor: !isEmailValid ? '#ff4d4f' : undefined,
            }}
          />
          <HelperText>{TEMPLATE_FORM_CONSTANTS.MESSAGES.FROM_EMAIL_REQUIRED}</HelperText>
          {!isEmailValid && <ErrorText>{TEMPLATE_FORM_CONSTANTS.MESSAGES.INVALID_EMAIL}</ErrorText>}
        </div>

        <div>
          <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.FROM_NAME}</FormLabel>
          <FormInput
            type="text"
            value={formData.fromName}
            onChange={(e) => onFormChange('fromName', e.target.value)}
            placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.FROM_NAME}
          />
        </div>

        <div>
          <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.REPLY_TO}</FormLabel>
          <FormInput
            type="email"
            value={formData.replyTo}
            onChange={(e) => onFormChange('replyTo', e.target.value)}
            placeholder={TEMPLATE_FORM_CONSTANTS.PLACEHOLDERS.REPLY_TO}
          />
        </div>
      </FormGridRow>
    </FormSection>
  );
};

export default FormEmailConfig;
